<!--发票单管理-->
<template>
  <div class='standardTabs AC_F_ORDER_INVOICE'>
    <Tabs v-model='auditStatusFull'
          :animated='false'
          @on-click='tabClickFun'>
      <TabPane v-for='(item,index) in tabArr' :key='index' :label='item.label'
               :name='`${item.searchName}-${item.name}`' />
    </Tabs>
  </div>
</template>

<script>
export default {
  name: 'orderInvoice',
  data() {
    return {
      searchName: '',
      auditStatus: 'ALL',
      auditStatusFull: '-ALL',
      tabArr: [
        {
          label: t('全部'),
          name: 'ALL',
          searchName: ''
        },
        {
          label: t('待审核'),
          name: '0',
          searchName: 'AUDIT_STATUS'
        },
        {
          label: t('待开票'),
          name: '0',
          searchName: 'INVOICE_STATUS'
        },
        {
          label: t('开票中'),
          name: '1',
          searchName: 'INVOICE_STATUS'
        },
        {
          label: t('已冻结'),
          name: '1',
          searchName: 'FREEZE_STATUS'
        },
        {
          label: t('已取消'),
          name: '1',
          searchName: 'CANCEL_STATUS'
        },
        {
          label: t('开票成功'),
          name: '2',
          searchName: 'INVOICE_STATUS'
        },
        {
          label: t('开票失败'),
          name: '3',
          searchName: 'INVOICE_STATUS'
        },
        {
          label: t('已冲红'),
          name: '1',
          searchName: 'RED_RUSH_STATUS'
        }
      ]
    };
  },
  mounted() {
    this.$nextTick(() => {
      $('.standardTabs').parent().parent().attr('style', 'order: 3 !important');
    });
    // 监听重置按钮点击事件
    const resetBtn = document.getElementById('reset');
    resetBtn.addEventListener('click', () => {
      this.auditStatusFull = '-ALL';
      this.searchName = '';
    }, false);
  },
  methods: {
    tabClickFun(name) {
      console.log(name, '---name');
      const _name = name.split('-')[1];
      this.auditStatus = _name;
      this.searchName = this.tabArr.filter(item => `${item.searchName}-${item.name}` === name)[0].searchName;
      this.$parent.$parent.$parent.searchEvent();
    }
  }
};
</script>
<style lang='less' scoped>
.standardTabs.AC_F_ORDER_INVOICE {
  /deep/ .ark-tabs-bar {
    margin-bottom: 0 !important;
  }
}
</style>
